import angular from 'angular';

angular
  .module('cxSettings')
  .controller('CompanyBankAccountsDialogCtrl', [
    '$element',
    '$http',
    '$scope',
    'authService',
    'appUrls',
    'flySvc',
    'close',
    'openIbanSvc',
    '$q',
    '$timeout',
    'companyId',
    'bankAccounts',
    companyBankAccountsDialogCtrl,
  ]);

function companyBankAccountsDialogCtrl(
  $element,
  $http,
  $scope,
  authService,
  appUrls,
  flySvc,
  close,
  openIbanSvc,
  $q,
  $timeout,
  companyId,
  bankAccounts,
) {
  var vm = this;
  vm.bankAccounts = angular.copy(bankAccounts);
  const originalBankAccounts = [...bankAccounts];
  const bankAccountsToDelete = [];
  const bankAccountsToUpdate = [];
  vm.newBankAccounts = [];

  vm.addBankAccount = () => {
    vm.newBankAccounts.push({});
  };

  vm.deleteBankAccount = bankAccount => {
    bankAccountsToDelete.push(bankAccount);

    // make sure we dont try to update a deleted bank account later
    const foundInToUpdate = bankAccountsToUpdate.indexOf(bankAccount.id);
    if (foundInToUpdate > -1) {
      bankAccountsToUpdate.splice(foundInToUpdate, 1);
    }
    const foundInBankAccounts = vm.bankAccounts.indexOf(bankAccount);
    if (foundInBankAccounts > -1) {
      vm.bankAccounts.splice(foundInBankAccounts, 1);
    }
  };

  vm.getBic = newBankAccount => {
    const params = { iban: newBankAccount.bankAccountNr };

    return $http.get(`${appUrls.api}/Api/Bank`, { params }).then(function({ data }) {
      if (!data) return;
      const copy = [...vm.newBankAccounts];
      const index = copy.indexOf(newBankAccount);
      if (index > -1) {
        copy[index] = {
          ...newBankAccount,
          bic: data.bic,
          bankName: data.name,
        };
        $timeout(function() {
          vm.newBankAccounts = copy;
        }, 100);
      }
    });
  };

  vm.bankAccountChanged = bankAccount => {
    const foundInToUpdate = bankAccountsToUpdate.indexOf(bankAccount.id);
    if (foundInToUpdate === -1) {
      bankAccountsToUpdate.push(bankAccount.id);
    }
  };

  vm.setBankAccountAsMain = (bankAccount, isNew) => {
    if (isNew) {
      vm.newBankAccounts = vm.newBankAccounts.map(newBankAccount => {
        return {
          ...newBankAccount,
          isMain: bankAccount == newBankAccount,
        };
      });
      vm.bankAccounts = vm.bankAccounts.map(oldBankAccount => {
        return {
          ...oldBankAccount,
          isMain: false,
        };
      });
    } else {
      vm.bankAccounts = vm.bankAccounts.map(oldBankAccount => {
        return {
          ...oldBankAccount,
          isMain: oldBankAccount == bankAccount,
        };
      });
      vm.newBankAccounts = vm.newBankAccounts.map(newBankAccount => {
        return {
          ...newBankAccount,
          isMain: false,
        };
      });

      const foundInToUpdate = bankAccountsToUpdate.indexOf(bankAccount.id);
      if (foundInToUpdate === -1) {
        bankAccountsToUpdate.push(bankAccount.id);
      }
    }
  };

  vm.save = () => {
    if (
      !vm.newBankAccounts.length &&
      !bankAccountsToDelete.length &&
      !bankAccountsToUpdate.length
    ) {
      close(originalBankAccounts, 500);
      return;
    }

    const model = {
      companyId,
      newBankAccounts: vm.newBankAccounts,
      updatedBankAccounts: bankAccountsToUpdate.map(bankAccountId => {
        return vm.bankAccounts.find(x => x.id === bankAccountId);
      }),
      deletedBankAccounts: bankAccountsToDelete.map(x => x.id),
    };
    vm.saving = true;
    return $http.put(`${appUrls.api}/api/company/${companyId}/bankaccounts`, model).then(
      ({ data }) => {
        vm.saving = false;
        $element.modal('hide');
        close(data, 500);
      },
      error => {
        vm.saving = false;
        flySvc.error(error);
      },
    );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(originalBankAccounts, 500);
  };
}
